import { Flex, Text } from '@chakra-ui/react';

export const Seperator = ({ seperatorConfig = {} }) => {
  const { textStyles, containerStyles, title } = seperatorConfig;
  return (
    <Flex {...containerStyles}>
      <Text {...textStyles}>{title}</Text>
    </Flex>
  );
};
